import { render } from "./StarRating.vue?vue&type=template&id=1f22e281&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=1f22e281&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f22e281"]])

export default __exports__